const FieldTypes = {
  BUTTON_GROUP: 'button-group',
  DATE_TIME: 'date-time',
  CONTACT_FORM: 'contact-form',
  TEXT_FIELD: 'text-field',
  MULTILINE_FIELD: 'multi-field',
};

export default FieldTypes;
